import React, { useEffect } from "react";
import { NotificationProps } from "../../types";

const Notification: React.FC<NotificationProps> = ({ message, type, onClose }) => {
    useEffect(() => {
        if (message) {
            const timer = setTimeout(onClose, 3000);
            return () => clearTimeout(timer);
        }
    }, [message, onClose]);

    if (!message) return null;

    return (
        <div
            className={`notification notification--toast ${type === "success" ? "success" : "error"} ${message ? 'active' : ''}`}
        >
            {message}
        </div>
    );
};

export default Notification;
